import React, { useState } from 'react'
import { Button, Col, Row, Typography, message } from 'antd'
import handleAxiosError from 'utils/handleAxiosError'
import getWalletReport from 'api/walletReport/getWalletReport'
import { PaginationState } from 'types'

const { Title } = Typography
interface PropType {
	pagination: PaginationState
}
const WalletReportHeader: React.FC<PropType> = ({ pagination }) => {
	const [loading, setLoading] = useState(false)

	const handleDownload = async () => {
		setLoading(true)
		try {
			await getWalletReport({
				page: pagination.currentPage,
				size: pagination.pageSize,
				should_export: 'YES',
			})
			message.success('Report will be sent on email ')
		} catch (error: any) {
			handleAxiosError(error)
		} finally {
			setLoading(false)
		}
	}

	return (
		<Row justify='space-between'>
			<Col>
				<Title level={3}>Wallet Report</Title>
			</Col>
			<Col>
				<Button
					type='primary'
					onClick={handleDownload}
					loading={loading}
					disabled={loading}
				>
					Download report
				</Button>
			</Col>
		</Row>
	)
}

export default WalletReportHeader
